//@flow
import React from 'react';
import Link from '../../../components/Link';
import {SubPageLinks} from '../../Header/config/subPages';
import SocialLink from '../../SocialLink/components/SocialLink.react';

const SUPPORT_EMAIL = 'support@naturebox.com';
const LYRA_LINK = 'https://naturebox-public-files.s3.amazonaws.com/NatureBox+Case+Study+-+Lyra+Health+(final+draft).pdf';
const KAISER_LINK = 'https://naturebox-public-files.s3.amazonaws.com/Fulton_County_Kaiser_Case_Study.pdf';

const renderSocialLinks = () => {
  const url = `https://naturebox.com/office`;
  const text = "NatureBox";

  const socialLinks = [
    {
      platform: "facebook",
      url,
      text,
      shareLink: false,
    },
    {
      platform: "instagram",
      url,
      text,
      shareLink: false,
    },
    {
      platform: "linkedIn",
      url,
      text,
      shareLink: false,
    },
    {
      platform: "twitter",
      url,
      text,
      shareLink: false,
    },
  ];

  return (
    <div className="social-links">
      {socialLinks.map((item, index) => (
        <SocialLink {...item} key={index} />
      ))}
    </div>
  );
};

const config = {
  sections: [
    {
      title: 'NatureBox',
      items: [
        {
          link: '/aboutus',
          label: 'About Us',
        },
        {
          link: '/blog',
          label: 'Blog',
        },
        {
          link: '/office/podcast',
          label: 'Podcast',
        },
        {
          link: '/office/refer',
          label: 'Refer an Office',
        },
      ],
    },
    {
      title: 'Use Cases',
      items: SubPageLinks.map((item => {
        return {
          link: item.link,
          label: item.label,
        };
      })),
    },
    {
      title: 'Case Studies',
      items: [
        {
          link: LYRA_LINK,
          label: 'Lyra Health',
        },
        {
          link: KAISER_LINK,
          label: 'Kaiser & Fulton County, GA',
        },
      ],
    },
    {
      title: 'Contact Us',
      items: [
        {
          link: `mailto:${SUPPORT_EMAIL}`,
          label: SUPPORT_EMAIL,
        },
        {
          link: '',
          label: renderSocialLinks(),
        },
      ],
    },
  ],
};

export default function OfficeFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="office-footer">
      <div className="office-footer-inner">
        <div className="office-footer-sections">
          {config.sections.map((section, index) => (
            <div className="office-footer-section" key={index}>
              <h2>{section.title}</h2>
              <ul className="section-items">
                {section.items.map((item, i) => {
                  let content;
                  if (item.link) {
                    content = (
                      <Link to={item.link} external={true}>{item.label}</Link>
                    );
                  } else {
                    content = item.label;
                  }
                  return <li key={i}>{content}</li>;
                })}
              </ul>
            </div>
          ))}
        </div>
        <div className="office-footer-bottom">
          &copy; {year} NatureBox &amp; NatureBox.com
        </div>
      </div>
    </footer>
  );
}
